<template>
  <v-app :theme="settings.theme">
    <LanguajeSelector v-if="!esLogin" />
    <v-main>
      <router-view />
      <!-- Aquí se renderizarán las rutas -->
      <v-alert
        v-if="unauthorizedAlert"
        type="warning"
        class="position-fixed top-0 left-0 right-0 mx-auto mt-4"
        style="max-width: 400px; z-index: 1000"
        border="start"
        elevation="8"
        closable
        @click:close="unauthorizedAlert = false"
      >
        {{ mensaje }}
      </v-alert>
    </v-main>
  </v-app>
</template>

<script>
import LanguajeSelector from "./components/Global/LanguajeSelector.vue";
import { useSettingsStore } from "@/stores/settings";
export default {
  name: "App",

  components: {
    LanguajeSelector,
  },
  computed: {
    settings() {
      return useSettingsStore();
    },
    // En login el selector de idioma se muestra dentro de la pantalla (arriba
    // a la derecha), asi que ocultamos el global para no duplicarlo.
    esLogin() {
      return this.$route?.name === "LoginPage";
    },
  },
  data: () => ({
    // Esto solo si es necesario porque va redireccionar
    unauthorizedAlert: false,
    mensaje: "",
  }),
  created() {
    window.addEventListener("unauthorized", this.showUnauthorizedAlert);
    window.addEventListener("forbidden", this.showUnauthorizedAlert);
    window.addEventListener("storage", this.onSessionChange);
  },
  beforeUnmount() {
    window.removeEventListener("unauthorized", this.showUnauthorizedAlert);
    window.removeEventListener("forbidden", this.showUnauthorizedAlert);
    window.removeEventListener("storage", this.onSessionChange);
  },
  methods: {
    // Sesion unica por navegador: si otra ventana inicia sesion, la sesion
    // activa cambia; esta pestaña ya no es la activa → salimos a login.
    onSessionChange(e) {
      if (e.key !== "active_session") return;
      const mine = sessionStorage.getItem("my_session");
      if (mine && e.newValue && e.newValue !== mine) {
        window.location.href = "/index";
      }
    },
    showUnauthorizedAlert(event) {
      ////console.log(event.detail.mensaje)
      if (this.alertTimeout) {
        clearTimeout(this.alertTimeout);
      }
      this.mensaje = event.detail.mensaje;
      this.unauthorizedAlert = true;

      this.alertTimeout = setTimeout(() => {
        this.unauthorizedAlert = false;
      }, 5000);
    },
  },
};
</script>
